import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { logout } from "@features/auth/auth.slice";

export const useHeaderVM = () => {

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleLogoutClick = () => {
    dispatch(logout());
    navigate("/login");
  };

  return {
    handleLogoutClick
  };
};